import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Toolbar = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px',
}));

export const MetricGroup = styled(Box)(() => ({
  display: 'inline-flex',
  padding: '4px',
  gap: '2px',
  borderRadius: '10px',
  backgroundColor: protoColors.surfaceSubtle,
  border: `1px solid ${protoColors.border}`,
}));

export const MetricButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ active }) => ({
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 600,
  padding: '6px 12px',
  borderRadius: '7px',
  color: active ? protoColors.surface : protoColors.textMuted,
  backgroundColor: active ? protoColors.purple : 'transparent',
  '&:hover': {
    color: active ? protoColors.surface : protoColors.purple,
  },
}));

export const Select = styled('select')(() => ({
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 500,
  color: protoColors.textPrimary,
  padding: '8px 12px',
  borderRadius: '10px',
  border: `1px solid ${protoColors.border}`,
  backgroundColor: protoColors.surface,
  cursor: 'pointer',
}));

export const Count = styled('span')(() => ({
  marginLeft: 'auto',
  fontSize: '13px',
  color: protoColors.textMuted,
}));

export const Layout = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 380px',
  gap: '16px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const SideColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));
